import React from 'react';

export default function TermsAndConditionsEN() {
  return (
    <div>
      <p>
        The online store
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>{' '}
        is operated by&nbsp;<strong>UAB Imunodiagnostika</strong>, registered address: Molėtų g. 16, Didžioji Riešė,
        Vilnius district, Lithuania.
        <br />
        &nbsp;Company code: 303064228
        <br />
        &nbsp;VAT code: LT100008020911
        <br />
        &nbsp;Phone: +370 685 98360
      </p>

      <h2>
        <strong>1. General Terms</strong>
      </h2>
      <h3>
        <strong>Definitions</strong>
      </h3>
      <ul>
        <li>
          <strong>Terms</strong> – These Terms and Conditions of the online store
          <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
            &nbsp;
            <strong>
              <u>www.self.co</u>
            </strong>
          </a>
          .
        </li>
        <li>
          <strong>Imunodiagnostika</strong> – UAB Imunodiagnostika, Molėtų g. 16, Didžioji Riešė, Vilnius district,
          Lithuania. &nbsp;
        </li>
        <li>
          <strong>Agreement</strong> – The service agreement or order confirmation that confirms the purchase of
          services through the online store, including any documents attached to the order confirmation.
        </li>
        <li>
          <strong>Order</strong> – The specific service or product ordered, prepared according to the data provided by
          the Client or Recipient.
        </li>
        <li>
          <strong>Client</strong> – The individual listed as the party to the Agreement who accepts these Terms and
          Conditions.
        </li>
        <li>
          <strong>Recipient</strong> – The person who can use the services purchased by the Client.
        </li>
        <li>
          <strong>Store</strong> – The online store referred to in these Terms.
        </li>
        <li>
          <strong>Product / Service</strong> – Any product or service sold through the Store.
        </li>
        <li>
          <strong>Agreement Date</strong> – The date when Imunodiagnostika activates the purchased services and the
          Client receives an order confirmation.
        </li>
        <li>
          <strong>Clinic</strong> – A partner clinic of Imunodiagnostika that collects the Client’s sample.
        </li>
      </ul>
      <p>
        These Terms override any other documents the Client may receive in connection with the Store’s operation.
        <br />
        &nbsp;Submitting an order confirms that the Client has read, understood, and accepted these Terms in full.
      </p>
      <p>
        Any adult with full legal capacity can become a Client.
        <br />
        &nbsp;The Agreement is concluded in accordance with the laws of the Republic of Lithuania and in the Lithuanian
        language.
        <br />
        &nbsp;These Terms are an integral part of the service agreement and define the conditions of sale and use.
        <br />
        &nbsp;By accepting these Terms, the Client also agrees to receive documents and communications electronically.
      </p>
      <p>Imunodiagnostika is responsible for the quality of the services provided.</p>

      <h2>
        <strong>2. Personal Data Processing and Security</strong>
      </h2>
      <p>
        By placing an order, you agree that Imunodiagnostika is the controller of your personal data and may process it
        for the following purposes:
      </p>
      <ul>
        <li>To conclude and perform the Agreement</li>
        <li>To inform you about new services, products, and promotions</li>
        <li>For archiving and statistical purposes</li>
      </ul>
      <p>
        You have the right to opt out of receiving promotional information by sending a free-form request to&nbsp;
        <strong>hello@self.co</strong>.<br />
        &nbsp;You also have the right to request deletion of your personal data if it does not conflict with legal
        requirements. Providing data is voluntary.
      </p>
      <p>
        In accordance with the Lithuanian Law on Legal Protection of Personal Data (Articles 13 and 14), your personal
        data – including name, surname, gender, date of birth, email address, phone number, and address – may be shared
        with Imunodiagnostika and the Clinic.
      </p>

      <h2>
        <strong>3. Orders and Order Confirmations</strong>
      </h2>
      <p>
        Orders for services can be placed at
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>{' '}
        24 hours a day, 7 days a week, except during technical downtime.
      </p>
      <p>
        An order is valid only if the Client correctly configures the service as described on the website and pays for
        it in full online.
      </p>
      <p>
        The Client must enter accurate personal information to ensure proper processing of the order. Orders with
        incorrect or incomplete information may be manually reviewed and, if necessary, cancelled by Imunodiagnostika.
        In such cases, the Client will be notified within 3 business days by phone or email.
      </p>
      <p>
        Imunodiagnostika will confirm the order within 24 hours after receiving payment by contacting the Client by
        phone or email and will inform the Clinic about the Client’s sample collection appointment. Confirmation may
        take longer if the order is placed on weekends or public holidays.
      </p>
      <p>
        An order will&nbsp;<strong>not</strong> be processed if:
      </p>
      <ul>
        <li>The Client provides incorrect or invalid information</li>
        <li>The Client cannot be reached using the provided contact details</li>
        <li>The order is submitted incorrectly</li>
        <li>
          Imunodiagnostika suspects that the order violates laws or exceeds the Client’s legal authority (e.g., identity
          fraud or unauthorized access)
        </li>
      </ul>
      <p>
        The Client must use the purchased services within&nbsp;<strong>30 days</strong> of payment. If the Client does
        not visit the Clinic to provide a sample within this period, the services will be considered fully provided.
      </p>
      <p>
        The standard time for completing the services is&nbsp;<strong>7 business days</strong> from the date of sample
        collection.
      </p>

      <h2>
        <strong>4. Payments</strong>
      </h2>
      <p>
        The total price for the order is shown at the third step of the checkout process. The displayed price is the
        final price, including all taxes and fees.
      </p>
      <p>
        Payments must be made online through
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>{' '}
        using the Mollie payment system.
        <br />
        &nbsp;All prices are listed in euros and include VAT.
        <br />
        &nbsp;There are no additional fees other than those charged by the Client’s bank.
      </p>

      <h2>
        <strong>5. Termination of the Agreement</strong>
      </h2>
      <p>
        Before the start of service provision (i.e., before the sample is collected), the Client may cancel the
        Agreement by emailing&nbsp;<strong>hello@self.co</strong>.
      </p>
      <p>
        Imunodiagnostika guarantees a refund of the paid amount within&nbsp;<strong>14 days</strong> to the same bank
        account used for payment, with no additional costs to the Client.
      </p>
      <p>
        Once service provision has started (after sample collection), the Agreement cannot be cancelled. At that point,
        the services are considered fully provided.
      </p>

      <h2>
        <strong>6. Contact and Complaints</strong>
      </h2>
      <p>Clients can contact us with questions, suggestions, or issues regarding the Store in the following ways:</p>
      <ul>
        <li>
          By email:&nbsp;<strong>hello@self.co</strong>
        </li>
        <li>By phone: +370 640 65680 (Mon–Fri, 9:00–18:00)</li>
      </ul>
      <p>
        Complaints must be submitted&nbsp;<strong>in writing</strong>.
      </p>
      <ul>
        <li>
          Service-related complaints are handled within&nbsp;<strong>10 business days</strong>.<br />
        </li>
        <li>
          Medical-related complaints are handled within&nbsp;<strong>30 business days</strong> from the date all
          required information is received.
        </li>
      </ul>
      <p>
        Mailing address for complaints: Molėtų g. 16, Didžioji Riešė, Vilnius district, or by email at&nbsp;
        <strong>hello@self.co</strong>.
      </p>
      <p>Phone calls are charged according to the Client’s standard tariff plan.</p>
      <p>
        If a legal dispute arises, the parties agree that it will be resolved in the&nbsp;
        <strong>Vilnius District Court</strong> or&nbsp;<strong>Vilnius Regional Court</strong>, depending on the value
        of the claim.
      </p>

      <h2>
        <strong>7. Final Provisions</strong>
      </h2>
      <p>
        Imunodiagnostika reserves the right to update these Terms.
        <br />
        &nbsp;The latest version will always be available at
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>
        .<br />
        &nbsp;Updated Terms take effect immediately upon publication.
      </p>
      <p>
        Imunodiagnostika also reserves the right to change prices and product availability, launch or cancel promotions,
        and modify them at any time.
      </p>
      <p>Imunodiagnostika is not responsible for any actions of third parties that cause damage to the Client.</p>

      <p>
        ✅&nbsp;<strong>Effective date:</strong> These Terms and Conditions apply from the moment they are published on
        <a target="_blank" rel="noopener noreferrer" href="http://www.self.co/">
          &nbsp;
          <strong>
            <u>www.self.co</u>
          </strong>
        </a>
      </p>
    </div>
  );
}
